import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import Packages from '../pages/Packages.vue'
import Hotels from '../pages/Hotels.vue'
import Flights from '../pages/Flights.vue'
import Ziarat from '../pages/Ziarat.vue'
import Services from '../pages/Services.vue'
import About from '../pages/About.vue'
import Gallery from '../pages/Gallery.vue'
import Reviews from '../pages/Reviews.vue'
import Contact from '../pages/Contact.vue'

import AdminLogin from '../pages/admin/AdminLogin.vue'
import AdminLayout from '../pages/admin/AdminLayout.vue'
import AdminDashboard from '../pages/admin/AdminDashboard.vue'
import AdminPackages from '../pages/admin/AdminPackages.vue'
import AdminHotels from '../pages/admin/AdminHotels.vue'
import AdminServices from '../pages/admin/AdminServices.vue'
import AdminZiarat from '../pages/admin/AdminZiarat.vue'
import AdminGallery from '../pages/admin/AdminGallery.vue'
import AdminReviews from '../pages/admin/AdminReviews.vue'
import AdminVouchers from '../pages/admin/AdminVouchers.vue'
import AdminInvoices from '../pages/admin/AdminInvoices.vue'
import AdminChangePassword from '../pages/admin/AdminChangePassword.vue'
import AdminCompanies from '../pages/admin/AdminCompanies.vue'
import LedgerEdit from '../pages/admin/LedgerEdit.vue'
import VoucherPrint from '../pages/admin/VoucherPrint.vue'
import InvoicePrint from '../pages/admin/InvoicePrint.vue'
import LedgerPrint from '../pages/admin/LedgerPrint.vue'
import VoucherView from '../pages/VoucherView.vue'
import InvoiceView from '../pages/InvoiceView.vue'

import { getCurrentUser } from '../services/authStore'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/packages',
    name: 'Packages',
    component: Packages
  },
  {
    path: '/hotels',
    name: 'Hotels',
    component: Hotels
  },
  {
    path: '/flights',
    name: 'Flights',
    component: Flights
  },
  {
    path: '/ziarat',
    name: 'Ziarat',
    component: Ziarat
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: Reviews
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/voucher/:id',
    name: 'VoucherView',
    component: VoucherView
  },
  {
    path: '/invoice/:id',
    name: 'InvoiceView',
    component: InvoiceView
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'AdminDashboard', component: AdminDashboard },
      { path: 'packages', name: 'AdminPackages', component: AdminPackages },
      { path: 'hotels', name: 'AdminHotels', component: AdminHotels },
      { path: 'services', name: 'AdminServices', component: AdminServices },
      { path: 'ziarat', name: 'AdminZiarat', component: AdminZiarat },
      { path: 'gallery', name: 'AdminGallery', component: AdminGallery },
      { path: 'reviews', name: 'AdminReviews', component: AdminReviews },
      { path: 'vouchers', name: 'AdminVouchers', component: AdminVouchers },
      { path: 'invoices', name: 'AdminInvoices', component: AdminInvoices },
      { path: 'ledger', name: 'AdminCompanies', component: AdminCompanies },
      { path: 'ledger/edit/:companyId', name: 'LedgerEdit', component: LedgerEdit },
      { path: 'change-password', name: 'AdminChangePassword', component: AdminChangePassword }
    ]
  },
  {
    path: '/admin/vouchers/print/:id',
    name: 'VoucherPrint',
    component: VoucherPrint,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/invoices/print/:id',
    name: 'InvoicePrint',
    component: InvoicePrint,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/ledger/print/:companyId',
    name: 'LedgerPrint',
    component: LedgerPrint,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(async to => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return true
  }

  const user = await getCurrentUser()
  if (user) {
    return true
  }

  return { path: '/admin/login', query: { redirect: to.fullPath } }
})

export default router
